<div class="card" (click)="clickHandler">
  <div class="inner-grid">
    <div class="span-col-2">
      <p><b>{{title}}</b></p>
      <p>{{number}}</p>
      <p>{{description}}</p>
      <ng-content></ng-content>
    </div>
    <div class="span-row-2">
      <p><small>{{addDate}}</small></p>
      <img #imglogo style="display:table-cell; height: 50px; max-width: 50px; cursor: pointer;" src="{{thumbNail}}" />
    </div>
  </div>
</div>
